/*
  Maldita Livraria: a ficha da assinatura em duas colunas.

  O tema arruma os blocos do produto dentro de um layout-stack, que é um
  componente com shadow DOM e faz o seu próprio empilhamento. Por isso o CSS
  de fora não o consegue transformar em grelha: os blocos entram por um slot e
  quem os posiciona é uma caixa que vive dentro do componente.

  A saída é dar-lhe um filho só, nosso, e arrumar os blocos lá dentro. À
  esquerda o que se lê, à direita o que se compra, e em baixo a recolha e a
  partilha.
*/
(function () {
  function arrumar() {
    var meta = document.querySelector('.product-single__meta');
    if (!meta || meta.querySelector('.ml-colunas')) return;

    var filhos = Array.prototype.slice.call(meta.children);
    if (filhos.length === 0) return;

    var caixa = document.createElement('div');
    caixa.className = 'ml-colunas';
    var esquerda = document.createElement('div');
    esquerda.className = 'ml-colunas__lado ml-colunas__lado--ler';
    var direita = document.createElement('div');
    direita.className = 'ml-colunas__lado ml-colunas__lado--comprar';
    var fundo = document.createElement('div');
    fundo.className = 'ml-colunas__fundo';
    caixa.appendChild(esquerda);
    caixa.appendChild(direita);
    caixa.appendChild(fundo);

    function lado(el) {
      var nome = el.tagName.toLowerCase();

      // o que se compra
      if (
        nome === 'block-quantity-selector' ||
        nome === 'block-buy-buttons' ||
        (el.classList && el.classList.contains('shopify-app-block'))
      ) {
        return direita;
      }

      // o que fica em baixo, a toda a largura
      if (el.querySelector('ul.social-sharing')) {
        el.classList.add('ml-colunas__partilha');
        return fundo;
      }

      if (nome === 'store-availability' || el.querySelector('.store-availability')) {
        el.classList.add('ml-colunas__recolha');
        return fundo;
      }

      // tudo o resto é para ler
      return esquerda;
    }

    filhos.forEach(function (el) {
      // os scripts de módulo ficam onde estão, para não correrem outra vez
      if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;
      lado(el).appendChild(el);
    });

    meta.appendChild(caixa);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrumar);
  } else {
    arrumar();
  }

  // no editor do tema a secção volta a ser desenhada de raiz
  document.addEventListener('shopify:section:load', arrumar);
})();
